import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface BulkAddTagsRequest {
  parentIds: Array<string>;
  tagId: string;
  studioId: string;
}

export interface BulkAddTagsError {
  parentId: string;
  error: string;
}

export interface BulkAddTagsResponse {
  success: boolean;
  added: number;
  failed: number;
  errors: Array<BulkAddTagsError>;
}

export const bulkAddTagsAPI = async (
  params: BulkAddTagsRequest,
): Promise<BulkAddTagsResponse> => {
  const response = await baseAPI.post<BulkAddTagsResponse>(
    '/parents/bulk-add-tag',
    params,
  );
  return response.data;
};

export const useBulkAddTagsMutation = () => {
  return useMutation({
    mutationFn: bulkAddTagsAPI,
    onSuccess: () => {
      // Invalidate parent tags queries to refresh tag data
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PARENT_TAGS],
      });
      // Invalidate parent list to refresh UI
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PARENTS],
      });
    },
  });
};
